// Import all files in this directory and subdirectories
// This is needed for Webpack to bundle all TypeScript files

import {CDN_BASE_URL} from "../config/cdn";

const context = require.context('./', true, /\.tsx$/);
context.keys().forEach(context);

// Normal imports
import React from 'react';
import { createRoot } from 'react-dom/client';

import PrestaGlobals from './common/PrestaGlobals';
import MainScreen from './layout/MainScreen';

/**
 * Application entry point
 */
const App: React.FC = () => {
    const shopInfo = {
        domain: PrestaGlobals.shopURL,
        shopFolder: PrestaGlobals.virtualUri,
        token: "DummyToken",
        isLoggedIn: PrestaGlobals.isLoggedIn,
        cdn: CDN_BASE_URL
    };

    return (
        <MainScreen shopInfo={shopInfo} />
    );
};

// Inject the App component into the root element
const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(<App />);
}
